import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import TemplateEditor from '../components/integrations/TemplateEditor'
import integrationService from '../services/integrationService'

const TemplateEditorPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [template, setTemplate] = React.useState<any>(null)
  const [loading, setLoading] = React.useState(!!id)

  React.useEffect(() => {
    if (id) {
      loadTemplate()
    }
  }, [id])

  const loadTemplate = async () => {
    try {
      const data = await integrationService.getTemplate(id!)
      setTemplate(data)
    } catch (error) {
      console.error('Failed to load template:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSave = async (templateData: any) => {
    try {
      if (id) {
        await integrationService.updateTemplate(id, templateData)
      } else {
        await integrationService.createTemplate(templateData)
      }
      navigate('/admin/integrations/templates')
    } catch (error) {
      console.error('Failed to save template:', error)
    }
  }

  const handleCancel = () => {
    navigate('/admin/integrations/templates')
  }

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading template...</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {id ? 'Edit Template' : 'Create Template'}
      </Typography>
      <TemplateEditor
        initialTemplate={template}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </Box>
  )
}

export default TemplateEditorPage
